import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Col, Row } from "components/bootstrap";
import { DocumentTitle, Link, PageHeader } from "components/common";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import AIFeaturesStatusAlerts from "ai-management/components/AIFeaturesStatusAlerts";
import usePermissions from "hooks/usePermissions";
import AIManagementRoutes from "ai-management/Routes";
import columnRenderers from "./AgentWorkflows/ColumnRenderers";
import { ADDITIONAL_ATTRIBUTES, DEFAULT_LAYOUT } from "./AgentWorkflows/Constants";
import useWorkflowDefinitions from "./AgentWorkflows/hooks/useWorkflowDefinitions";
import AgentWorkflowPageNavigation from "./AgentWorkflowPageNavigation";
const AgentWorkflowsPage = () => {
  const { t } = useTranslation("enterprise_ai");
  const { fetchWorkflowDefinitions, keyFn } = useWorkflowDefinitions();
  const { isPermitted } = usePermissions();
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("agent_workflows_page.document_title") }, /* @__PURE__ */ React.createElement(AgentWorkflowPageNavigation, null), /* @__PURE__ */ React.createElement(PageHeader, { title: t("agent_workflows_page.title") }, /* @__PURE__ */ React.createElement("span", null, isPermitted("agent_workflow:manage") ? /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "agent_workflows_page.description_with_link",
      components: { modelProvidersLink: /* @__PURE__ */ React.createElement(Link, { to: AIManagementRoutes.MODEL_PROVIDERS }) }
    }
  ) : t("agent_workflows_page.description"))), /* @__PURE__ */ React.createElement(AIFeaturesStatusAlerts, null), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: t("agent_workflows_page.human_name"),
      tableLayout: DEFAULT_LAYOUT,
      fetchEntities: fetchWorkflowDefinitions,
      keyFn,
      columnRenderers,
      additionalAttributes: ADDITIONAL_ATTRIBUTES,
      entityAttributesAreCamelCase: false,
      noPageSizeSelect: true
    }
  ))));
};
export default AgentWorkflowsPage;
